//Mahesh S : 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings- Start
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzCard, BzChip, BzInputText } from '../../../../../components';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ORDER_TYPES, ORDERS_TABKEY, TL_INDEX, SESSION_STORAGE_KEYS, EXCHANGE_NAME_LIVEPULSE } from '../../../../../utils/global_variables';
import { StatusChip } from '../../../../Orders';
import ZeroStates from '../../../../ZeroStates';
import { handleModal, handleModalData } from '../../../../../redux/actions/modals';
import { useWFHMessages } from '../../../../../hooks';
import { ordersFilters } from '../../../../../controllers/netPosition';
import { updateFilters } from '../../../../../redux/actions/orders';
import { _getOrderDisplayStatus } from '../../../../../controllers';
import moment from 'moment';
import CustomVirtualizer from '../../../../../components/CustomVirtulaizer';
import { setStorageWithMultiTabCheckWithoutEncryption } from '../../../../../utils/global_functions';

const MultiLeg = () => {
    const dispatch = useDispatch();


    const [arrOrders, setArrOrders] = useState([]);
    const [searchText, setSearchText] = useState();
    const [isSearchShoing, setIsSearchShowing] = useState(false);
    const objFilterData = useSelector(state => state?.orders?.objFilterData);
    const holdingsScrips = useSelector(state => state.holdings?.holdingsScrips);
    const modalData = useSelector(state => state.modals?.modalData);
    const arrMultilegAllOrders = useSelector(state => state?.orders?.arrMultilegAllOrders); //Ajitesh 15-07-2024 - Multileg Pagination for sidebar

    useEffect(() => {
        setArrOrders(arrMultilegAllOrders);
    }, [arrMultilegAllOrders]);


    const onSearchChange = (value) => {
        setSearchText(value);
    };

    const onSearchClose = () => {
        setSearchText();
        setIsSearchShowing(false);
    };

    useEffect(() => {
        if (arrMultilegAllOrders?.length > 0) {
            if (searchText?.length > 0) {
                const filteredPositions = arrMultilegAllOrders.filter((each) => each.spread_symbol?.toLowerCase().includes(searchText?.toLowerCase()));
                setArrOrders(filteredPositions);
            } else {
                setArrOrders(arrMultilegAllOrders);
            }
        } else { }
    }, [searchText, arrMultilegAllOrders]);

    const handleMultiScripLtp = useCallback((arrTouchLineData) => {
        let copyArrOrders = [...arrOrders];
        if (arrOrders && arrOrders?.length > 0) {
            arrOrders?.forEach((each, i) => {
                if (each?.segment_id + "_" + each.spread_token + "_" + each?.order_id === arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN] + "_" + each?.order_id) {
                    const objScripToBeUpdated = each;
                    objScripToBeUpdated.ltp = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE];
                    if (Object.keys(objScripToBeUpdated)?.length > 0) {
                        copyArrOrders[i] = objScripToBeUpdated;
                        setArrOrders([...copyArrOrders]);
                    } else { }
                } else { }
            });
        } else { }
    }, [arrOrders]);

    useWFHMessages('touchline', (e) => {
        const arrTouchlineReq = [...e.detail];
        handleMultiScripLtp(arrTouchlineReq);
    });

    //Vaibhav Singh: 05-02-24: BT-107431: Updated Filter Lofic : Start
    // Adds proper filter names for all segments on UI; so NSE_CUR -> NSECDS, NSE_FO -> NSE; when filter applied values will be compared using what is shown on UI using global variable
    const allExchangeList = [...new Set(arrMultilegAllOrders?.map(element => EXCHANGE_NAME_LIVEPULSE[element?.exchange]))];
    const allProductType = [...new Set(arrMultilegAllOrders?.map(element => element?.exchangeWiseProductType ? element?.exchangeWiseProductType : element?.prod_type))];
    // Vinit R : 12-03-2024 : NSE FAO Watchlist Sidetray - Orders, Positions and Holdings -- Start
    const orderStatusFilters = [...new Set(arrMultilegAllOrders?.map(orders => _getOrderDisplayStatus(orders?.status)))];

    const handleFilters = () => {
        if (arrMultilegAllOrders?.length) {
            dispatch(handleModal([{ "FILTER_ORDER_POSITION_MODAL": true }]));
            dispatch(handleModalData({ type: 'Orders', allExchangeList: allExchangeList, allProductType: allProductType, orderStatusFilters, isAllowedBuy: false, isAllowedAmnt: false }));
        }
    };

    // Ajitesh: Function to handle filtration in sidetray orderbook for multileg
    const filteredData = useMemo(() => {
        if (modalData?.filter !== undefined && Object?.keys(modalData?.filter)?.length) {
            let filteredArray = ordersFilters(modalData?.filter, arrOrders);
            if (searchText?.length > 0) {
                filteredArray = filteredArray?.filter((each) => {
                    const keywords = searchText?.toString()?.toLowerCase()?.split(' ');
                    let strRowData = each?.spread_symbol + each?.exchange;
                    return keywords?.every(keyword => strRowData?.toLowerCase()?.includes(keyword));
                });
            }
            return filteredArray;
        }
        else {
            if (searchText?.length > 0) {
                const filteredPositions = arrOrders?.filter((each) => {
                    const keywords = searchText?.toString()?.toLowerCase()?.split(' ');
                    let strRowData = each?.spread_symbol + each?.exchange;
                    return keywords?.every(keyword => strRowData?.toLowerCase()?.includes(keyword));
                });
                return filteredPositions;
            }
            else {
                return arrOrders;
            }
        }
    }, [modalData, searchText, arrOrders]);


    const navigate = useNavigate();
    const handleRedirectMultiLegOrder = useCallback((id) => {
        let path = `/orders?section=${ORDER_TYPES.MULTI_LEG}&ordertype=${ORDERS_TABKEY.ALL_ORDERS}`;
        navigate(path, { state: id });
        setStorageWithMultiTabCheckWithoutEncryption(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
    }, [navigate]);
    const handleClickChips = (ele) => {
        delete objFilterData[ele];
        dispatch(handleModalData({ filter: objFilterData }));
        dispatch(updateFilters(objFilterData));
    };










    const renderItem = useCallback(({ index, data, style }) => {
        let each = data[index];
        return (
            <div key={index} style={style}>
                <BzCard key={index} className='transparent-card cursor-pointer bdr-btm' onClick={() => handleRedirectMultiLegOrder(each?.order_id)}>
                    <Row className='g-0'>
                        <Col md={6} className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size3 color-text text-uppercase me-2'>{each?.spread_symbol}</div>
                            <div className='chips-wrap'>
                                <BzChip className='exchange-chip me-2'>{each?.exchange === "NSE_CUR" ? "NSECDS" : each?.exchange === "BSE_CUR" ? 'BSECDS' : each?.exchange.split('_')[0]}</BzChip> {/**Ajitesh 26-07-2024 Adds condition to show NSECDS and BSECDS for currency derv in sidetray orderbook */}
                            </div>
                        </Col>
                        <Col md={6} className='orderstatus-chips-wrap d-flex justify-content-end align-items-center'>
                            <div className='chips-wrap'>
                                <StatusChip data={each} strClass='d-flex justify-content-end align-items-center' />
                            </div>
                        </Col>
                    </Row>
                    {/* // Parshva S : 2/4/2024 : BT:102679 Multileg Orders Start  */}
                    <Row className='g-0 mb-1'>
                        <Col className='d-flex'>
                            {(holdingsScrips?.some(element => element?.nMarketSegmentId + '_' + element?.nToken === each?.MktSegId + '_' + each?.scripToken) ?
                                <div className='icon-16 icon-portfolio icon-dark ms-2'></div> : null)}
                            <div className='font-regular font-size2 color-subtext text-uppercase'>{moment(each?.leg_no_1?.expiry_date).format("DD MMM 'YY")?.toUpperCase()} {each?.leg_no_1?.instrument?.slice(0, 3)}</div>

                        </Col>
                    </Row>
                    <Row className='g-0 mb-1'>
                        <Col md={6} className='d-flex justify-content-start align-self-center'>
                            <BzChip className="chips primary-chip me-1">{each?.leg_indicator === "2L" ? "2 Leg" : "3 Leg"}</BzChip>
                            <BzChip className="chips primary-chip">Multileg</BzChip>
                        </Col>
                    </Row>
                    <Row className='g-0'>
                        <Col md={6} className='d-flex justify-content-start align-self-center'>
                            <div className='d-flex align-self-center font-regular font-size1 color-subtext me-2'>{moment(each?.order_modified_timestamp).format("hh:mm:ss A, DD MMM 'YY").toUpperCase()}</div>
                        </Col>
                    </Row>
                    {/* // Parshva S : 2/4/2024 : BT:102679 Multileg Orders End  */}
                </BzCard>
            </div>
        );
    }, [holdingsScrips, handleRedirectMultiLegOrder]);

    return (
        <>
            <Container fluid className='p-0 px-3'>
                <Row className='g-0 py-1 mb-2 h_40'>
                    <Col md={9} className='d-flex align-items-center'>
                        {
                            isSearchShoing ?
                                <>
                                    <div className='position-relative w-70'>
                                        <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                        <BzInputText autoFocus onChange={(e) => onSearchChange(e.target.value)} size='sm' type='search' placeholder="Search here" className='p-l-30 font-regular scripname-searchtext'></BzInputText>
                                    </div>
                                    <div className='icon-16 icon-dark icon-close ms-2' onClick={() => onSearchClose()} />
                                </>
                                : null
                        }
                    </Col>
                    {/* <Col md={3} className='d-flex justify-content-start align-items-center'>&nbsp;</Col> */}
                    <Col md={3} className='d-flex justify-content-end align-items-center'>
                        <div onClick={() => arrMultilegAllOrders?.length ? setIsSearchShowing(true) : null} className={`icon-16 icon-search ${arrMultilegAllOrders?.length ? 'icon-dark' : 'icon-grey'}`}></div>
                        <div className={`icon-16 icon-searchfilter ${arrMultilegAllOrders?.length ? 'icon-dark' : 'icon-grey'} ms-3`} onClick={handleFilters}></div>
                        <Link to='/orders?section=multi_leg'>
                            <div className='icon-14 icon-redirect icon-dark ms-3'></div>
                        </Link>
                    </Col>
                </Row>
                {Object.keys(objFilterData)?.length ?
                    <Row className='g-0 mb-3'>
                        <Col className='d-flex'>
                            <div className='font-medium font-size3 color-text m-1'>Filters:</div>
                            <div className='horizontal-scroll-wrap filters-chips-wrap flex-nowrap'>
                                {Object.keys(objFilterData)?.map((ele, i) => {
                                    return <div key={i} className='chips chips default-chip text-capitalize m-1'>
                                        {objFilterData[ele] === "low_high" ? `${ele} : Low-High` : objFilterData[ele] === "high_low" ? `${ele} : High-Low` : parseFloat(objFilterData[ele]) ? `${ele.slice(-3)} : ${objFilterData[ele]}` : `${ele} : ${objFilterData[ele]}`} <div style={{ width: "6px", height: '6px', marginLeft: "6px" }} onClick={handleClickChips?.bind(this, ele)} className='icon-16 icon-dark icon-close'></div>
                                    </div>;
                                })
                                }
                            </div>
                        </Col>
                    </Row>
                    : null
                }
            </Container>
            {/* //Vaibhav Singh: 05-02-24: BT-107431: Updated Filter Lofic : End */}
            {arrMultilegAllOrders?.length > 0 ?
                <Container fluid className='p-0'>
                    <div className='sticky-orderpositions-height px-3' >
                        <Row className='g-0 h-100'>
                            <Col>
                                <div className='p-0 h-100'>
                                    <div className='transparent-card-wrap mb-2 h-100'>

                                        {/* ManasaB : 10-09-2024 : Hotfix issue  - Start*/}
                                        {filteredData?.length > 0 ? <CustomVirtualizer data={filteredData} itemHeight={126} renderItem={renderItem} segmentId={'segment_id'} token={'spread_token'} /> :
                                            <div className='zero-state-alerts zero-state-alerts-xl'>
                                                <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                                                <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                                                <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                                            </div>
                                        }
                                        {/* ManasaB : 10-09-2024 : Hotfix issue  - End*/}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
                :
                <div className='zero-state-alerts zero-state-alerts-xl'>
                    <ZeroStates subText="No orders available" icon='icon-100 icon-nodata mb-2 mrgauto' />
                </div>
            }
        </>
    );
};

export default memo(MultiLeg);
//Mahesh S : 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings- End
